module.exports = __webpack_public_path__ + "static/img/slip_liegend3.0c5ea9dd.png";